import { FormGroup, TextField, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { observer } from 'mobx-react'
import { ComponentProps } from 'react'
import {
	PropsEditorComponent,
	ValuesEditorComponent,
	specifyValueTypeComponent,
} from '../../../FormBuilderCore/cells/ComponentSpecification'
import { useFormBuilderContext } from '../../../FormBuilderCore/cells/rendering/contexts/FormBuilderContext'
import { useInputCellContext } from '../../../FormBuilderCore/cells/rendering/contexts/InputContextProvider'
import { FieldType } from '../../../FormHost/Types/FieldType'
import {
	ListPropertyConfigurator,
	PropertySchematicConfigurator,
	TextPropertyConfigurator,
} from '../../Configuration'
import { changeEventEmitter } from '../../EventBus/BuiltInEvents/ChangeEvent'
import { focusEventEmitter } from '../../EventBus/BuiltInEvents/FocusEvent'

type TextListInputProps = {
	label: string
}

export const TextListInput = observer((props: TextListInputProps) => {
	console.log('TEXT LIST INPUT!!!')

	const { cellManager } = useFormBuilderContext()
	const context = useInputCellContext<string[]>()

	/* swapping to Static from Javascript gives us an empty string, 
		 which we can't map so we have to assign empty array if we don't already
		 have an array*/
	const realValue =
		context.value !== null && Array.isArray(context.value) ? context.value : []

	return (
		<Box
			component={FormGroup}
			flex={1}
			overflow="hidden"
			onBlur={() => {
				focusEventEmitter(
					cellManager.eventBus,
					{
						focusType: 'FocusLost',
					},
					{
						formHost: cellManager,
						elementTag: TextListElementTag,
						definitionId: context.cellInstance.definitionId,
						instanceId: context.cellInstance.id,
					},
				)
			}}
		>
			<Typography variant="subtitle1" color="textPrimary">
				{props.label}
			</Typography>
			<Box display="flex" flexDirection="column" gap={1}>
				{realValue.map((v, i) => (
					<TextField
						fullWidth
						size="small"
						value={v}
						onChange={(evt) => {
							const newValue = [...(context.value ?? [])]
							newValue[i] = evt.target.value
							context.onChange(newValue)

							changeEventEmitter(
								cellManager.eventBus,
								{
									oldValue: context.value,
									newValue: newValue,
								},
								{
									formHost: cellManager,
									elementTag: TextListElementTag,
									definitionId: context.cellInstance.definitionId,
									instanceId: context.cellInstance.id,
								},
							)
						}}
					/>
				))}
			</Box>
		</Box>
	)
})

export const TextListElementTag = 'f842a64b-4159-424a-9e22-d8d822cdead0'

const TextListInputId = 'ecad6356-e1f6-49dc-8aae-778650c58e70'

const TextListInputPropsEditor = ({
	properties,
	onPropertiesChanged,
}: PropsEditorComponent<ComponentProps<typeof TextListInput>>) => {
	return (
		<>
			<PropertySchematicConfigurator
				value={properties.label}
				onValueChanged={(v) => onPropertiesChanged({ ...properties, label: v })}
				Editor={TextPropertyConfigurator}
				label="Label"
			/>
		</>
	)
}

const TextListInputValueEditor = (
	props: ValuesEditorComponent<ComponentProps<typeof TextListInput>>,
) => (
	<PropertySchematicConfigurator
		value={props.value}
		onValueChanged={props.onValueChanged}
		Editor={ListPropertyConfigurator} // TODO
		label="Default Value"
	/>
)

export const TextListInputDefinition = specifyValueTypeComponent(
	TextListInputId,
	TextListInput,
	TextListElementTag,
	'Text List',
	FieldType.StringArray,
	{
		configurator: TextListInputPropsEditor,
		defaultProperties: {
			label: 'Label',
		},
	},
	{
		configurator: TextListInputValueEditor,
		defaultValue: [],
	},
)
